import {
  Box,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Spinner,
  Text,
  useTimeout,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { requestServerApi, serverApi } from '../../../../../api/api';
import ModalHeaderComponent from '../../../../../components/ModalHeader';
import StoryStudyRecords from './StoryStudyRecords';
import { PieChart } from 'react-minimal-pie-chart';

interface StudyRecordInterface {
  chapter_id: string;
  correct: number;
  first_end: string; 
  first_start: string;
  last_end: string;
  learner_id: string;
  learner_name: string;
  max_quiz_attempt: number;
  study_status: 'Complete' | 'Studying';
  total: number;
}

interface StudyStats {
  totalCorrect: number;
  totalIncorrect: number;
}

type Props = {
  onClose: (name: string, response: any) => void;
};

export default function StoryStudyHistoryModal({ onClose }: Props) {
  const company_id: string = useParams<any>().companyId;
  const learner_id: string = useParams<any>().learnerId;
  const [storyRecords, setStoryRecords] = useState<any[]>([]);
  const [fetchCompleted, setFetchCompleted] = useState(false);
  const [correct, setCorrect] = useState(0);
  const [incorrect, setInCorrect] = useState(0);

  const closeModal = () => {
    onClose('storyStudyHistoryModal', '');
  };

  const getRecords = () => {
    // NOTE 学習記録を１APIで取得しているため、ここで取得するのが一番効率がいい（ただし分けたほうが負荷が少なくなると思う）
    const apiResponse = requestServerApi<any>(() =>
      serverApi.organizationsControllerGetLearnerStudyRecords(company_id, learner_id),
    );
    apiResponse.then((data) => {
      const apiStoryRecords: StudyRecordInterface[] = data.data.data[0]?.storyRecords;
      setStoryRecords(apiStoryRecords);
      setFetchCompleted(true);
      const { totalCorrect, totalIncorrect } = calculateStat(apiStoryRecords);
      setCorrect(totalCorrect);
      setInCorrect(totalIncorrect);
    });
  };
  useTimeout(() => {
    // useEffectで開いたと同時に処理を初めると若干重くなるため、少しずらす
    getRecords();
  }, 100);

  const calculateStat = (apiStoryRecords: StudyRecordInterface[]): StudyStats => {
    let totalCorrect = 0;
    let totalIncorrect = 0;

    for (const item of apiStoryRecords) {
      totalCorrect += item.correct;
      totalIncorrect += item.total - item.correct;
    }

    return { totalCorrect, totalIncorrect };
  }

  const COLORS = {
    correct: '#4CAF50',
    incorrect: '#71717a',
  };

  const data = [
    {
      title: 'Correct',
      value: correct / (correct + incorrect) * 100,
      color: COLORS.correct,
    },
    {
      title: 'Incorrect',
      value: incorrect / (correct + incorrect) * 100,
      color: COLORS.incorrect,
    },
  ];

  return (
    <>
      <Modal isOpen={true} onClose={closeModal}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeaderComponent title="ストーリー" />

          <ModalBody>
            <Flex overflowY="auto" height="500px" direction={'column'}>
              <Flex direction={'column'} mb={4}>
                <Text fontWeight={"bold"}>
                  ストーリー実施進捗
                </Text>
                {correct + incorrect > 0 ? 
                  <Box maxW={"60%"} bgColor={"yellow.400"} my={2}>
                    <PieChart
                      data={data}
                      animate
                      radius={35}
                      animationDuration={500}
                      animationEasing="ease-out"
                      segmentsShift={2}
                      label={({ dataEntry }) =>
                        dataEntry.title === 'Correct'
                          ? `${Math.round(dataEntry.value)}%`
                          : ''
                      }
                      labelStyle={{
                        fill: 'white',
                        fontSize: '6px',
                      }}
                      labelPosition={65}
                      totalValue={100}
                    />
                  </Box> : 
                  <Text fontSize={"sm"} color={"gray.500"}>
                    ストーリーを実施していません
                  </Text>
                }
                
              </Flex>
              {fetchCompleted ? (
                <StoryStudyRecords storyRecords={storyRecords} />
              ) : (
                <Box marginX="auto" marginY="10">
                  <Spinner color="teal" />
                </Box>
              )}
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
